import { jsx as B } from "react/jsx-runtime";
import * as C from "react";
import { useLayoutEffect as q, useEffect as l, useContext as b, useState as G, useRef as M, useImperativeHandle as P, useMemo as x, memo as p, forwardRef as T } from "react";
import { createPortal as W } from "react-dom";
const $ = C.createContext(null);
function J(t, n) {
  const e = Array.isArray(t) ? t[0] : t ? t.x : 0, i = Array.isArray(t) ? t[1] : t ? t.y : 0, r = Array.isArray(n) ? n[0] : n ? n.x : 0, o = Array.isArray(n) ? n[1] : n ? n.y : 0;
  return e === r && i === o;
}
function h(t, n) {
  if (t === n)
    return !0;
  if (!t || !n)
    return !1;
  if (Array.isArray(t)) {
    if (!Array.isArray(n) || t.length !== n.length)
      return !1;
    for (let e = 0; e < t.length; e++)
      if (!h(t[e], n[e]))
        return !1;
    return !0;
  } else if (Array.isArray(n))
    return !1;
  if (typeof t == "object" && typeof n == "object") {
    const e = Object.keys(t), i = Object.keys(n);
    if (e.length !== i.length)
      return !1;
    for (const r of e)
      if (!n.hasOwnProperty(r) || !h(t[r], n[r]))
        return !1;
    return !0;
  }
  return !1;
}
function N(t) {
  return {
    longitude: t.center.lng,
    latitude: t.center.lat,
    zoom: t.zoom,
    pitch: t.pitch,
    bearing: t.bearing,
    padding: t.padding
  };
}
function O(t, n) {
  const e = n.viewState || n, i = {};
  if ("longitude" in e && "latitude" in e && (e.longitude !== t.center.lng || e.latitude !== t.center.lat)) {
    const r = t.center.constructor;
    i.center = new r(e.longitude, e.latitude);
  }
  return "zoom" in e && e.zoom !== t.zoom && (i.zoom = e.zoom), "bearing" in e && e.bearing !== t.bearing && (i.bearing = e.bearing), "pitch" in e && e.pitch !== t.pitch && (i.pitch = e.pitch), e.padding && t.padding && !h(e.padding, t.padding) && (i.padding = e.padding), i;
}
const K = ["type", "source", "source-layer", "minzoom", "maxzoom", "filter", "layout"];
function A(t) {
  if (!t)
    return null;
  if (typeof t == "string" || ("toJS" in t && (t = t.toJS()), !t.layers))
    return t;
  const n = {};
  for (const i of t.layers)
    n[i.id] = i;
  const e = t.layers.map((i) => {
    let r = null;
    "interactive" in i && (r = Object.assign({}, i), delete r.interactive);
    const o = n[i.ref];
    if (o) {
      r = r || Object.assign({}, i), delete r.ref;
      for (const s of K)
        s in o && (r[s] = o[s]);
    }
    return r || i;
  });
  return { ...t, layers: e };
}
const U = { version: 8, sources: {}, layers: [] }, I = {
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  click: "onClick",
  dblclick: "onDblClick",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  mouseout: "onMouseOut",
  contextmenu: "onContextMenu",
  touchstart: "onTouchStart",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchcancel: "onTouchCancel"
}, F = {
  movestart: "onMoveStart",
  move: "onMove",
  moveend: "onMoveEnd",
  dragstart: "onDragStart",
  drag: "onDrag",
  dragend: "onDragEnd",
  zoomstart: "onZoomStart",
  zoom: "onZoom",
  zoomend: "onZoomEnd",
  rotatestart: "onRotateStart",
  rotate: "onRotate",
  rotateend: "onRotateEnd",
  pitchstart: "onPitchStart",
  pitch: "onPitch",
  pitchend: "onPitchEnd"
}, D = {
  wheel: "onWheel",
  boxzoomstart: "onBoxZoomStart",
  boxzoomend: "onBoxZoomEnd",
  boxzoomcancel: "onBoxZoomCancel",
  resize: "onResize",
  load: "onLoad",
  render: "onRender",
  idle: "onIdle",
  remove: "onRemove",
  data: "onData",
  styledata: "onStyleData",
  sourcedata: "onSourceData",
  error: "onError"
}, Y = [
  "minZoom",
  "maxZoom",
  "minPitch",
  "maxPitch",
  "maxBounds",
  "projection",
  "renderWorldCopies"
], Q = [
  "scrollZoom",
  "boxZoom",
  "dragRotate",
  "dragPan",
  "keyboard",
  "doubleClickZoom",
  "touchZoomRotate",
  "touchPitch"
];
class S {
  constructor(n, e, i) {
    this._map = null, this._internalUpdate = !1, this._hoveredFeatures = null, this._propsedCameraUpdate = null, this._styleComponents = {}, this._onEvent = (r) => {
      const o = this.props[D[r.type]];
      o ? o(r) : r.type === "error" && console.error(r.error);
    }, this._onCameraEvent = (r) => {
      if (this._internalUpdate)
        return;
      r.viewState = this._propsedCameraUpdate || N(this._map.transform);
      const o = this.props[F[r.type]];
      o && o(r);
    }, this._onCameraUpdate = (r) => this._internalUpdate ? r : (this._propsedCameraUpdate = N(r), O(r, this.props)), this._onPointerEvent = (r) => {
      (r.type === "mousemove" || r.type === "mouseout") && this._updateHover(r);
      const o = this.props[I[r.type]];
      o && (this.props.interactiveLayerIds && r.type !== "mouseover" && r.type !== "mouseout" && (r.features = this._hoveredFeatures || this._queryRenderedFeatures(r.point)), o(r), delete r.features);
    }, this._MapClass = n, this.props = e, this._initialize(i);
  }
  get map() {
    return this._map;
  }
  setProps(n) {
    const e = this.props;
    this.props = n;
    const i = this._updateSettings(n, e), r = this._updateSize(n), o = this._updateViewState(n);
    this._updateStyle(n, e), this._updateStyleComponents(n), this._updateHandlers(n, e), (i || r || o && !this._map.isMoving()) && this.redraw();
  }
  static reuse(n, e) {
    const i = S.savedMaps.pop();
    if (!i)
      return null;
    const r = i.map, o = r.getContainer();
    for (e.className = o.className; o.childNodes.length > 0; )
      e.appendChild(o.childNodes[0]);
    r._container = e;
    const s = r._resizeObserver;
    s && (s.disconnect(), s.observe(e)), i.setProps({ ...n, styleDiffing: !1 }), r.resize();
    const { initialViewState: a } = n;
    return a && (a.bounds ? r.fitBounds(a.bounds, { ...a.fitBoundsOptions, duration: 0 }) : i._updateViewState(a)), r.isStyleLoaded() ? r.fire("load") : r.once("style.load", () => r.fire("load")), r._update(), i;
  }
  /* eslint-disable complexity,max-statements */
  _initialize(n) {
    const { props: e } = this, { mapStyle: i = U } = e, r = {
      ...e,
      ...e.initialViewState,
      container: n,
      style: A(i)
    }, o = r.initialViewState || r.viewState || r;
    if (Object.assign(r, {
      center: [o.longitude || 0, o.latitude || 0],
      zoom: o.zoom || 0,
      pitch: o.pitch || 0,
      bearing: o.bearing || 0
    }), e.gl) {
      const a = HTMLCanvasElement.prototype.getContext;
      HTMLCanvasElement.prototype.getContext = () => (HTMLCanvasElement.prototype.getContext = a, e.gl);
    }
    const s = new this._MapClass(r);
    o.padding && s.setPadding(o.padding), e.cursor && (s.getCanvas().style.cursor = e.cursor), s.transformCameraUpdate = this._onCameraUpdate, s.on("style.load", () => {
      this._styleComponents = {
        light: s.getLight(),
        sky: s.getSky(),
        // @ts-ignore getProjection() does not exist in v4
        projection: s.getProjection?.(),
        terrain: s.getTerrain()
      }, this._updateStyleComponents(this.props);
    }), s.on("sourcedata", () => {
      this._updateStyleComponents(this.props);
    });
    for (const a in I)
      s.on(a, this._onPointerEvent);
    for (const a in F)
      s.on(a, this._onCameraEvent);
    for (const a in D)
      s.on(a, this._onEvent);
    this._map = s;
  }
  /* eslint-enable complexity,max-statements */
  recycle() {
    this.map.getContainer().querySelector("[mapboxgl-children]")?.remove(), S.savedMaps.push(this);
  }
  destroy() {
    this._map.remove();
  }
  // Force redraw the map now. Typically resize() and jumpTo() is reflected in the next
  // render cycle, which is managed by Mapbox's animation loop.
  // This removes the synchronization issue caused by requestAnimationFrame.
  redraw() {
    const n = this._map;
    n.style && (n._frame && (n._frame.cancel(), n._frame = null), n._render());
  }
  /* Trigger map resize if size is controlled
     @param {object} nextProps
     @returns {bool} true if size has changed
   */
  _updateSize(n) {
    const { viewState: e } = n;
    if (e) {
      const i = this._map;
      if (e.width !== i.transform.width || e.height !== i.transform.height)
        return i.resize(), !0;
    }
    return !1;
  }
  // Adapted from map.jumpTo
  /* Update camera to match props
     @param {object} nextProps
     @param {bool} triggerEvents - should fire camera events
     @returns {bool} true if anything is changed
   */
  _updateViewState(n) {
    const e = this._map, i = e.transform;
    if (!e.isMoving()) {
      const o = O(i, n);
      if (Object.keys(o).length > 0)
        return this._internalUpdate = !0, e.jumpTo(o), this._internalUpdate = !1, !0;
    }
    return !1;
  }
  /* Update camera constraints and projection settings to match props
     @param {object} nextProps
     @param {object} currProps
     @returns {bool} true if anything is changed
   */
  _updateSettings(n, e) {
    const i = this._map;
    let r = !1;
    for (const o of Y)
      o in n && !h(n[o], e[o]) && (r = !0, i[`set${o[0].toUpperCase()}${o.slice(1)}`]?.call(i, n[o]));
    return r;
  }
  /* Update map style to match props */
  _updateStyle(n, e) {
    if (n.cursor !== e.cursor && (this._map.getCanvas().style.cursor = n.cursor || ""), n.mapStyle !== e.mapStyle) {
      const { mapStyle: i = U, styleDiffing: r = !0 } = n, o = {
        diff: r
      };
      "localIdeographFontFamily" in n && (o.localIdeographFontFamily = n.localIdeographFontFamily), this._map.setStyle(A(i), o);
    }
  }
  /* Update fog, light, projection and terrain to match props
   * These props are special because
   * 1. They can not be applied right away. Certain conditions (style loaded, source loaded, etc.) must be met
   * 2. They can be overwritten by mapStyle
   */
  _updateStyleComponents({ light: n, projection: e, sky: i, terrain: r }) {
    const o = this._map, s = this._styleComponents;
    o.style._loaded && (n && !h(n, s.light) && (s.light = n, o.setLight(n)), e && !h(e, s.projection) && e !== s.projection?.type && (s.projection = typeof e == "string" ? { type: e } : e, o.setProjection?.(s.projection)), i && !h(i, s.sky) && (s.sky = i, o.setSky(i)), r !== void 0 && !h(r, s.terrain) && (!r || o.getSource(r.source)) && (s.terrain = r, o.setTerrain(r)));
  }
  /* Update interaction handlers to match props */
  _updateHandlers(n, e) {
    const i = this._map;
    for (const r of Q) {
      const o = n[r] ?? !0, s = e[r] ?? !0;
      h(o, s) || (o ? i[r].enable(o) : i[r].disable());
    }
  }
  _queryRenderedFeatures(n) {
    const e = this._map, { interactiveLayerIds: i = [] } = this.props;
    try {
      return e.queryRenderedFeatures(n, {
        layers: i.filter(e.getLayer.bind(e))
      });
    } catch {
      return [];
    }
  }
  _updateHover(n) {
    const { props: e } = this;
    if (e.interactiveLayerIds && (e.onMouseMove || e.onMouseEnter || e.onMouseLeave)) {
      const r = n.type, o = this._hoveredFeatures?.length > 0, s = this._queryRenderedFeatures(n.point), a = s.length > 0;
      !a && o && (n.type = "mouseleave", this._onPointerEvent(n)), this._hoveredFeatures = s, a && !o && (n.type = "mouseenter", this._onPointerEvent(n)), n.type = r;
    } else
      this._hoveredFeatures = null;
  }
}
S.savedMaps = [];
const X = [
  "setMaxBounds",
  "setMinZoom",
  "setMaxZoom",
  "setMinPitch",
  "setMaxPitch",
  "setRenderWorldCopies",
  "setProjection",
  "setStyle",
  "addSource",
  "removeSource",
  "addLayer",
  "removeLayer",
  "setLayerZoomRange",
  "setFilter",
  "setPaintProperty",
  "setLayoutProperty",
  "setLight",
  "setTerrain",
  "setFog",
  "remove"
];
function tt(t) {
  if (!t)
    return null;
  const n = t.map, e = {
    getMap: () => n
  };
  for (const i of et(n))
    !(i in e) && !X.includes(i) && (e[i] = n[i].bind(n));
  return e;
}
function et(t) {
  const n = /* @__PURE__ */ new Set();
  let e = t;
  for (; e; ) {
    for (const i of Object.getOwnPropertyNames(e))
      i[0] !== "_" && typeof t[i] == "function" && i !== "fire" && i !== "setEventedParent" && n.add(i);
    e = Object.getPrototypeOf(e);
  }
  return Array.from(n);
}
const nt = typeof document < "u" ? q : l;
function ot(t, n) {
  const { RTLTextPlugin: e, maxParallelImageRequests: i, workerCount: r, workerUrl: o } = n;
  if (e && t.getRTLTextPluginStatus && t.getRTLTextPluginStatus() === "unavailable") {
    const { pluginUrl: s, lazy: a = !0 } = typeof e == "string" ? { pluginUrl: e } : e;
    t.setRTLTextPlugin(s, (c) => {
      c && console.error(c);
    }, a);
  }
  i !== void 0 && t.setMaxParallelImageRequests(i), r !== void 0 && t.setWorkerCount(r), o !== void 0 && t.setWorkerUrl(o);
}
const R = C.createContext(null);
function rt(t, n) {
  const e = b($), [i, r] = G(null), o = M(), { current: s } = M({ mapLib: null, map: null });
  l(() => {
    const u = t.mapLib;
    let E = !0, f;
    return Promise.resolve(u || import("./maplibre-gl-DPjjcZ-4.js").then((d) => d.m)).then((d) => {
      if (!E)
        return;
      if (!d)
        throw new Error("Invalid mapLib");
      const m = "Map" in d ? d : d.default;
      if (!m.Map)
        throw new Error("Invalid mapLib");
      ot(m, t), t.reuseMaps && (f = S.reuse(t, o.current)), f || (f = new S(m.Map, t, o.current)), s.map = tt(f), s.mapLib = m, r(f), e?.onMapMount(s.map, t.id);
    }).catch((d) => {
      const { onError: m } = t;
      m ? m({
        type: "error",
        target: null,
        originalEvent: null,
        error: d
      }) : console.error(d);
    }), () => {
      E = !1, f && (e?.onMapUnmount(t.id), t.reuseMaps ? f.recycle() : f.destroy());
    };
  }, []), nt(() => {
    i && i.setProps(t);
  }), P(n, () => s.map, [i]);
  const a = x(() => ({
    position: "relative",
    width: "100%",
    height: "100%",
    ...t.style
  }), [t.style]), c = {
    height: "100%"
  };
  return C.createElement("div", { id: t.id, ref: o, style: a }, i && C.createElement(
    R.Provider,
    { value: s },
    C.createElement("div", { "mapboxgl-children": "", style: c }, t.children)
  ));
}
const yt = C.forwardRef(rt), it = /box|flex|grid|column|lineHeight|fontWeight|opacity|order|tabSize|zIndex/;
function y(t, n) {
  if (!t || !n)
    return;
  const e = t.style;
  for (const i in n) {
    const r = n[i];
    Number.isFinite(r) && !it.test(i) ? e[i] = `${r}px` : e[i] = r;
  }
}
function Z(t, n) {
  if (t === n)
    return null;
  const e = j(t), i = j(n), r = [];
  for (const o of i)
    e.has(o) || r.push(o);
  for (const o of e)
    i.has(o) || r.push(o);
  return r.length === 0 ? null : r;
}
function j(t) {
  return new Set(t ? t.trim().split(/\s+/) : []);
}
const vt = p(T((t, n) => {
  const { map: e, mapLib: i } = b(R), r = M({ props: t }), o = x(() => {
    let w = !1;
    C.Children.forEach(t.children, (g) => {
      g && (w = !0);
    });
    const V = {
      ...t,
      element: w ? document.createElement("div") : void 0
    }, _ = new i.Marker(V);
    return _.setLngLat([t.longitude, t.latitude]), _.getElement().addEventListener("click", (g) => {
      r.current.props.onClick?.({
        type: "click",
        target: _,
        originalEvent: g
      });
    }), _.on("dragstart", (g) => {
      const v = g;
      v.lngLat = o.getLngLat(), r.current.props.onDragStart?.(v);
    }), _.on("drag", (g) => {
      const v = g;
      v.lngLat = o.getLngLat(), r.current.props.onDrag?.(v);
    }), _.on("dragend", (g) => {
      const v = g;
      v.lngLat = o.getLngLat(), r.current.props.onDragEnd?.(v);
    }), _;
  }, []);
  l(() => (o.addTo(e.getMap()), () => {
    o.remove();
  }), []);
  const { longitude: s, latitude: a, offset: c, style: u, draggable: E = !1, popup: f = null, rotation: d = 0, rotationAlignment: m = "auto", pitchAlignment: k = "auto" } = t;
  l(() => {
    y(o.getElement(), u);
  }, [u]), P(n, () => o, []);
  const H = r.current.props;
  (o.getLngLat().lng !== s || o.getLngLat().lat !== a) && o.setLngLat([s, a]), c && !J(o.getOffset(), c) && o.setOffset(c), o.isDraggable() !== E && o.setDraggable(E), o.getRotation() !== d && o.setRotation(d), o.getRotationAlignment() !== m && o.setRotationAlignment(m), o.getPitchAlignment() !== k && o.setPitchAlignment(k), o.getPopup() !== f && o.setPopup(f);
  const z = Z(H.className, t.className);
  if (z)
    for (const w of z)
      o.toggleClassName(w);
  return r.current.props = t, W(t.children, o.getElement());
})), st = p(T((t, n) => {
  const { map: e, mapLib: i } = b(R), r = x(() => document.createElement("div"), []), o = M({ props: t }), s = x(() => {
    const a = { ...t }, c = new i.Popup(a);
    return c.setLngLat([t.longitude, t.latitude]), c.once("open", (u) => {
      o.current.props.onOpen?.(u);
    }), c;
  }, []);
  if (l(() => {
    const a = (c) => {
      o.current.props.onClose?.(c);
    };
    return s.on("close", a), s.setDOMContent(r).addTo(e.getMap()), () => {
      s.off("close", a), s.isOpen() && s.remove();
    };
  }, []), l(() => {
    y(s.getElement(), t.style);
  }, [t.style]), P(n, () => s, []), s.isOpen()) {
    const a = o.current.props;
    (s.getLngLat().lng !== t.longitude || s.getLngLat().lat !== t.latitude) && s.setLngLat([t.longitude, t.latitude]), t.offset && !h(a.offset, t.offset) && s.setOffset(t.offset), (a.anchor !== t.anchor || a.maxWidth !== t.maxWidth) && (s.options.anchor = t.anchor, s.setMaxWidth(t.maxWidth));
    const c = Z(a.className, t.className);
    if (c)
      for (const u of c)
        s.toggleClassName(u);
    o.current.props = t;
  }
  return W(t.children, r);
}));
function L(t, n, e, i) {
  const r = b(R), o = x(() => t(r), []);
  return l(() => {
    const s = n, a = null, c = typeof n == "function" ? n : null, { map: u } = r;
    return u.hasControl(o) || (u.addControl(o, s?.position), a && a(r)), () => {
      c && c(r), u.hasControl(o) && u.removeControl(o);
    };
  }, []), o;
}
function at(t) {
  const n = L(({ mapLib: e }) => new e.AttributionControl(t), {
    position: t.position
  });
  return l(() => {
    y(n._container, t.style);
  }, [t.style]), null;
}
p(at);
function ct(t) {
  const n = L(({ mapLib: e }) => new e.FullscreenControl({
    container: t.containerId && document.getElementById(t.containerId)
  }), { position: t.position });
  return l(() => {
    y(n._controlContainer, t.style);
  }, [t.style]), null;
}
p(ct);
function lt(t, n) {
  const e = M({ props: t }), i = L(({ mapLib: r }) => {
    const o = new r.GeolocateControl(t), s = o._setupUI;
    return o._setupUI = () => {
      o._container.hasChildNodes() || s();
    }, o.on("geolocate", (a) => {
      e.current.props.onGeolocate?.(a);
    }), o.on("error", (a) => {
      e.current.props.onError?.(a);
    }), o.on("outofmaxbounds", (a) => {
      e.current.props.onOutOfMaxBounds?.(a);
    }), o.on("trackuserlocationstart", (a) => {
      e.current.props.onTrackUserLocationStart?.(a);
    }), o.on("trackuserlocationend", (a) => {
      e.current.props.onTrackUserLocationEnd?.(a);
    }), o;
  }, { position: t.position });
  return e.current.props = t, P(n, () => i, []), l(() => {
    y(i._container, t.style);
  }, [t.style]), null;
}
p(T(lt));
function ut(t) {
  const n = L(({ mapLib: e }) => new e.NavigationControl(t), {
    position: t.position
  });
  return l(() => {
    y(n._container, t.style);
  }, [t.style]), null;
}
const _t = p(ut);
function dt(t) {
  const n = L(({ mapLib: o }) => new o.ScaleControl(t), {
    position: t.position
  }), e = M(t), i = e.current;
  e.current = t;
  const { style: r } = t;
  return t.maxWidth !== void 0 && t.maxWidth !== i.maxWidth && (n.options.maxWidth = t.maxWidth), t.unit !== void 0 && t.unit !== i.unit && n.setUnit(t.unit), l(() => {
    y(n._container, r);
  }, [r]), null;
}
p(dt);
function ft(t) {
  const n = L(({ mapLib: e }) => new e.TerrainControl(t), {
    position: t.position
  });
  return l(() => {
    y(n._container, t.style);
  }, [t.style]), null;
}
p(ft);
function mt(t) {
  const n = L(({ mapLib: e }) => new e.LogoControl(t), { position: t.position });
  return l(() => {
    y(n._container, t.style);
  }, [t.style]), null;
}
p(mt);
const Ct = ({ longitude: t, latitude: n, content: e, offset: i, maxWidth: r, className: o, anchor: s }) => /* @__PURE__ */ B(
  st,
  {
    longitude: t,
    latitude: n,
    offset: i,
    className: o,
    maxWidth: r,
    anchor: s,
    closeButton: !1,
    closeOnClick: !1,
    children: e
  }
);
export {
  R as M,
  _t as N,
  Ct as P,
  yt as a,
  vt as b,
  h as d
};
